import React, { useState, useMemo } from 'react';
import { MasterDetailForm, Widget, FormInput, FormDatePicker, FormSubmitButton, FormatText, Button } from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { Esin204, RegistroEsin204 } from '../../api/esin204';
import Registros from './registros';
import UploadFile from '@app/components/uploadFile';
import { Tipo } from '@app/api/status';
import { exportaModelo } from '@app/api/exportaFile';
import ptBr from '../../i18n/ptBR/index';

const { Panel } = Collapse;
interface ImportacaoProp {
    esin204: Esin204,
    atualizarEsin204: () => any;
    handPostImportacaoRelatorioiIn204: (values: Esin204) => void;
    resultRegistroEsin204: RegistroEsin204[];
    hasFile: boolean;
    atualizarTabela: boolean;
    allTipoExecutadoAnoMesOptions: Tipo[],
    hasConsolidarExecutado: (esin204: Esin204) => void;
    hasExportarLinhaReclassificacao: (esin204: Esin204) => void;
    hasCreatRateioAutomativo: (esin204: Esin204) => void;
    hasHabilitarEdicao: (esin204: Esin204) => void;

}


const Importacao = (props: ImportacaoProp) => {
    const {
        esin204,
        atualizarEsin204,
        resultRegistroEsin204,
        handPostImportacaoRelatorioiIn204,
        hasFile,
        atualizarTabela,
        allTipoExecutadoAnoMesOptions,
        hasConsolidarExecutado,
        hasExportarLinhaReclassificacao,
        hasCreatRateioAutomativo,
        hasHabilitarEdicao
    } = props;
    const [esin204From, setEsin204From] = useState<Esin204>({} as Esin204);
    useMemo(() => {
        if (esin204) {
            setEsin204From(esin204);
        }
    }, [esin204]);

    const exportarModelo = (modelo: string) => {
        if (modelo) {
            exportaModelo(modelo);
        }
    };



    return (
        <>
            <Collapse
                bordered={false}
                defaultActiveKey={['importacaoRelatorioiIn204']}
                expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key="importacaoRelatorioiIn204" header={<span>IMPORTAÇÃO DO RELATÓRIO IN204 </span>} style={{ border: 0 }}>
                    <MasterDetailForm initialValues={esin204From} onSubmit={handPostImportacaoRelatorioiIn204}>
                        <Widget actions={
                            [
                                <Button
                                    type="link"
                                    icon="files-xls"
                                    onClick={() => {
                                        exportarModelo('modeloExecutado');
                                    }}>
                                    Modelo de importação executado
                                </Button>,
                                true && esin204From.totalRegistroEsin204 > 0 && (
                                    <FormSubmitButton
                                        confirm={esin204From.processado ? ptBr.mensagemProcessado : ptBr.mensagemNaoProcessado}
                                        cancelText={'Não'}
                                        okText={"Sim"}
                                    >
                                        <FormatText id="ui.commons.save" uppercase transform={() => 'IMPORTAR'} />
                                    </FormSubmitButton>
                                ),
                                true && esin204From.totalRegistroEsin204 === 0 && (
                                    <FormSubmitButton
                                        cancelText={'Não'}
                                        okText={"Sim"}
                                    >
                                        <FormatText id="ui.commons.save" uppercase transform={() => 'IMPORTAR'} />
                                    </FormSubmitButton>
                                ),
                            ]
                        }>
                            <FormInput label="Ciclo Orçamentário" name="ano" span={4} disabled />
                            <FormInput label="Mês" name="mes" span={4} disabled />
                            <FormInput label="Status" name="processadoDescricao" span={4} disabled />
                            <FormDatePicker
                                format="DD/MM/YYYY"
                                label="Data início"
                                name="dataInicio"
                                span={4}
                                disabled={true}
                            />
                            <FormDatePicker
                                format="DD/MM/YYYY"
                                label="Data fim"
                                name="dataFim"
                                span={4}
                                disabled={true}
                            />
                            <FormInput label="Valor Total - Importado" name="relatorioVlrTotalFormatado" span={4} disabled />
                            <FormInput label="Valor Total - Importado VRP" name="relatorioTelaVerbaRemanescenteProvisaoTotalFormatado" span={4} disabled />
                            <FormInput label="Valor Total - Consolidado" name="relatorioTotalConsolidadoExecutado" span={4} disabled />
                            <UploadFile
                                hasFile={hasFile}
                                accept=".xlsx"
                                label="Arquivo do relatório"
                                id="importFilePlanilha"
                                selectedItem={esin204From}
                            />

                        </Widget>
                    </MasterDetailForm>
                </Panel>
            </Collapse>

            {<Registros
                atualizarTabela={atualizarTabela}
                esin204={esin204}
                resultRegistroEsin204={resultRegistroEsin204}
                allTipoExecutadoAnoMesOptions={allTipoExecutadoAnoMesOptions}
                hasConsolidarExecutado={hasConsolidarExecutado}
                hasExportarLinhaReclassificacao={hasExportarLinhaReclassificacao}
                hasCreatRateioAutomativo={hasCreatRateioAutomativo}
                hasHabilitarEdicao={hasHabilitarEdicao}
            />}

        </>
    );
};

export default Importacao;


